import React,{useState, useEffect}  from 'react';
import Button from 'react-bootstrap/Button'
import Sides from '../Bars/Phpsidebar';
import { Helmet } from "react-helmet";

function PHPSetup()  {

    const [padding, setWindowpadding] = useState(0);
    const [width, setWindowWidth] = useState(0);
    useEffect(() => {
      updateDimensions()
  
      window.addEventListener('resize', updateDimensions)
      return () => window.removeEventListener('resize', updateDimensions)
    }, [])
  
    const updateDimensions = () => {
      const width = window.innerWidth
      setWindowWidth(width)
      if (width < 998) {
        setWindowpadding(2.5)
      } else {
        setWindowpadding(14)
      }
    }
  
    
    const right = {
      padding: '0 0 0 '+padding+'rem',
    };

    return(
          <div>
      <Sides/>

<Helmet>
 
 <title>Learn Free PHP Installation Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="php installation tutorial for beginners.Install xampp new version because XAMPP is an open-source software" />
 <meta name="keywords" content="codeexampler,php installation,install php,how to install php,how to install php in windows,programming language tutorial for begineers,phpmyadmin setup," />
 <link rel="canonical" href="https://www.codeexampler.com/php-setup" />
 </Helmet>

 <div className='lg:pl-56'>

<h1 className="m-4 mh1">Php Installation</h1>
<div className="first">
        <a href="/php-variables"><Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-keyword"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
<h2 className="mt-4 mh2">If you run PHP in chrome so Follow these Steps:
</h2>

<p className="mt-4 para ">1, Install xampp new version because XAMPP is an open-source software developed by <span className="bold">apachefriends</span>, so you open the<span className="bold"> apachefriends.org</span> and click the download option and download the latest version.<br/>
2, After download setup, double click on xampp setup and install full setup.<br/>
3, Open the xampp control panel and start apache, and if you use SQL, start Mysql.<br/>
4, Open localDisc(C:) and check xampp folder and go inside <span className="bold"> htdocs folder</span>and you create folder and give any name of this folder like(myphp) and after create a file inside myphp folder.<br/>
5, Open visual studio code after open myphp folder but <span className="bold"> php.validate.executablePath</span> not set.<br/>
6, Open visual studio code setting and search php.validate.executablePath and check php extensions and click on edit in setting.json and paste this code<span className="bold"> "php.validate.executablePath": "C:\\xampp\\php\\php.exe"</span>.<br/>
7, Type of code in visual studio inside (.php) file and after open google and type local (localhost/dashboard/ ) .when Welcome to XAMPP for Windows page is open so after type ( localhost/myphpfile/ ). and after open your file and php code run inside visual code.<br/><br/>
<span className="bold">Important : myphpfile.php </span>is a file name create inside a myphp folder<br/>
</p>

<h1 className="mt-5">  </h1>
   
   <div className="back">
         <a href="/php-variables"><Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
         <a href="/php-keyword"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
         </div>
        </div></div>
    )
} 
export default PHPSetup;